import { render, staticRenderFns } from "./insTypeContrast.vue?vue&type=template&id=b670eb54"
import script from "./insTypeContrast.vue?vue&type=script&lang=js"
export * from "./insTypeContrast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports